import { memo, useContext } from 'react';

import { SearchBar } from '@/components/ui/search/search.array';
import SearchContextProvider, {
  SearchContext
} from '@/components/ui/search/searchContext';
import {
  getSortConfig as getWidgetSortConfig,
  Widget
} from '@/components/ui/widget';
import type { WidgetData } from '@/components/ui/widget/widget.type';
import { getByPath, sortData } from '@/utils';
import { filterComments } from '@/utils/comment';
import type { ArrayView } from './array.type';

type Props = {
  view: ArrayView;
  data: WidgetData;
};

const ArrayViewImpl = memo(({ view, data }: Props) => {
  const { itemsPath, itemsWidget, defaultSort } = view;
  const { state: searchState } = useContext(SearchContext) || {};
  const items = getByPath(data, itemsPath);

  if (!Array.isArray(items)) {
    return null;
  }

  let itemsToDisplay = items;
  if (defaultSort) {
    const { direction } = defaultSort;
    const defaultSortConfig = getWidgetSortConfig(itemsWidget || {});
    itemsToDisplay = sortData(itemsToDisplay, defaultSortConfig, direction);
  }

  if (searchState?.string) {
    itemsToDisplay = filterComments(itemsToDisplay, searchState?.string);
  }
  return view.searchBar ? (
    <div className="flex flex-col flex-nowrap gap-3">
      <div className="absolute top-0 right-4">
        <SearchBar config={view.searchBar} />
      </div>
      {itemsToDisplay.map((item, index) => (
        // @ts-expect-error should be fixed when Widget is typed
        <Widget data={item} key={index} widget={itemsWidget} />
      ))}
      {itemsToDisplay.length === 0 && <div className="min-h-8" />}
    </div>
  ) : (
    <div className="flex flex-col flex-nowrap gap-3">
      {itemsToDisplay.map((item, index) => (
        // @ts-expect-error should be fixed when Widget is typed
        <Widget data={item} key={index} widget={itemsWidget} />
      ))}
    </div>
  );
});

const ArrayComponent = (props: Props) => {
  const searchBarConfig = props.view.searchBar;
  if (searchBarConfig) {
    return (
      <SearchContextProvider>
        <ArrayViewImpl {...props} />
      </SearchContextProvider>
    );
  }
  return <ArrayViewImpl {...props} />;
};

export const arrayViewProvider = {
  component: ArrayComponent
};
